import { STATUS_LABELS, STATUS_DOT } from "@/lib/site";

export default function StatusBadge({ status, className = "" }) {
  return (
    <span
      className={`fundio-status ${className}`}
    >
      <span aria-hidden="true" className="fundio-status-dot" style={{ background: STATUS_DOT[status] || "#777F88" }} />
      {STATUS_LABELS[status] || status || "—"}
    </span>
  );
}
